import { matchPath } from 'react-router-dom';

/**
 * Extracts the shipment number from a given pathname.
 * Matches patterns:
 * - /shipment/admin/edit/:shipmentNumber
 * - /shipment/history/:shipmentNumber
 */
export const extractShipmentNumber = (pathname: string): string => {
  const editMatch = matchPath('/shipment/admin/edit/:shipmentNumber', pathname);
  if (editMatch?.params.shipmentNumber) {
    return editMatch.params.shipmentNumber;
  }

  const historyMatch = matchPath('/shipment/history/:shipmentNumber', pathname);
  if (historyMatch?.params.shipmentNumber) {
    return historyMatch.params.shipmentNumber;
  }

  return '';
};
